import React from "react";
import PropTypes from "prop-types";
import ChatInputTextarea from "@web/components/ChatInputTextarea";
import ChatInputManager from "@web/ui/containers/ChatInputManager";
import {Button, Card, List, Typography, Tooltip} from "antd";
import {WorkflowsContext} from '@web/hooks/context';

AgentBuilder.propTypes = {
  instructions: PropTypes.string,
  tip: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onError: PropTypes.func,
  onMediaReady: PropTypes.func,
  selected: PropTypes.bool,
};

function AgentBuilder(props) {
  const [instructionsFocus, setInstructionsFocus] = React.useState(false);
  const onFocus = React.useCallback(() => {
    setInstructionsFocus(true);
    props.onFocus &&
    props.onFocus(true);
  }, [instructionsFocus]);
  const onBlur = React.useCallback(() => {
    setInstructionsFocus(false);
    props.onBlur &&
    props.onBlur();
  }, [instructionsFocus]);

  return <Card
    bordered={false}
    className="card-simple card-rounded card card-transparent"
  >
    {!props.selected ?
      <div
        style={{
          height: "100%",
          minHeight: "200px",
          padding: "20px 0",
          // marginTop: 30,
          // fontSize: props.instructions?.length <= 100 ? "24px" : "24px",
        }}
        className="space space-col middle center"
      >
        <Typography.Paragraph
          style={{fontSize: props.instructions?.length <= 100 ? "24px" : "24px"}}
          ellipsis={{rows: 10, expandable: true, symbol: "more"}}
          className={"muted render-line-breaks"}
        >
          {props.instructions || "Write instructions for your agent"}
      </Typography.Paragraph>
      </div>:
      <List
        size="large"
        header={
          <Tooltip title={<span>{props.tip}</span>} open={instructionsFocus}>
            <div className="space space-col large">
              <div className="space space-center-y space-between">
                <span className="font-xl bolded">Detailed Instructions</span>
              </div>
              <ChatInputManager
                maxLength={100000}
                pushPrompt={props.instructions ? {text: props.instructions} : null}
                onSend={props.onSave}
                onFocus={onFocus}
                onBlur={onBlur}
                onError={props.onError}
                onMediaReady={props.onMediaReady}
                placeholder={"Write instructions for your agent"}
                editorSize={{minRows: 2, maxRows: 10}}
                showCount
              >
                <ChatInputTextarea dictate={false} ai showButton />
              </ChatInputManager>
            </div>
        </Tooltip>
        }>
        <List.Item>
          <List.Item.Meta
            description={props.selected && props.children}
          />
        </List.Item>
      </List>
    }
  </Card>
}

export default AgentBuilder;
